import { ManageEmployeesEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(ManageEmployeesEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (queryString: string): Promise<any> =>
  APIManager.sendGet(
    ManageEmployeesEnds.GET_ALL(queryString),
    true,
    {},
    {},
    axios
  );

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(ManageEmployeesEnds.UPDATE(id), data, true, {}, {}, axios);

const detail = async (id: string): Promise<any> =>
  APIManager.sendGet(ManageEmployeesEnds.DETAIL(id), true, {}, {}, axios);

const deleteRecord = async (id: string): Promise<any> =>
  APIManager.sendDelete(ManageEmployeesEnds.DELETE(id), true, {}, {}, axios);

const resendInvite = async (id: string): Promise<any> =>
  APIManager.sendPost(
    ManageEmployeesEnds.RESEND_INVITE(id),
    {},
    true,
    {},
    {},
    axios
  );

const bulkUpload = async (form: FormData): Promise<any> =>
  APIManager.sendPost(
    ManageEmployeesEnds.BULK_UPLOAD,
    form,
    true,
    {},
    {},
    axios
  );

export const ManageEmployeesService = {
  create,
  getAll,
  update,
  detail,
  deleteRecord,
  resendInvite,
  bulkUpload,
};
